import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

export abstract class ConfirmDialogButtonBase {
  private _dialogRef: MatDialogRef<ConfirmationDialogComponent>;

  constructor(public dialog: MatDialog, public snackBar: MatSnackBar) { }

  openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }

  openDialog(title: string, content: string, confirmText: string, cancelText: string, config?: MatDialogConfig): void {
    config = Object.assign(new MatDialogConfig(), config, { width: '400px' });

    this._dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
    this._dialogRef.componentInstance.title = title;
    this._dialogRef.componentInstance.content = content;
    this._dialogRef.componentInstance.confirmText = confirmText;
    this._dialogRef.componentInstance.cancelText = cancelText;
    this._dialogRef.componentInstance.submit.subscribe(this.onSubmit.bind(this));
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  abstract onSubmit(value: any);
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/confirm-dialog-button-base.ts